import { Navigate, useParams } from 'react-router-dom'
import ProgramPageTemplate from '../../components/common/ProgramPageTemplate'
import LeadershipDevelopmentPage from './LeadershipDevelopmentPage'
import { programs } from '../../data/programs'

export default function ProgramPage() {
  const { slug } = useParams()

  if (slug === 'leadership-development') {
    return <LeadershipDevelopmentPage />
  }

  const data = programs[slug]

  if (!data) {
    return <Navigate to="/" replace />
  }

  return <ProgramPageTemplate data={data} />
}
